const ZONING_RULES_OPERATORS = {
  LESS_THAN: '<',
  LESS_THAN_OR_EQUAL_TO: '<=',
  GREATER_THAN: '>',
  GREATER_THAN_OR_EQUAL_TO: '>=',
  EQUAL: '=',
}

export const getZoningRules = (productList, productId) => {
  const product = productList.find(product => product.id === productId)
  const productZonningRules = product?.pricingRules?.zonningRules ?? []

  const result = {}

  productZonningRules.forEach(({ zone1, zone2, operator }) => {
    let keyZone, comparedZone, allowEqual, requireEqual = false;

    if (operator === ZONING_RULES_OPERATORS.EQUAL) {
      // Para igualdad, la comparación es estricta
      keyZone = zone1;
      comparedZone = zone2;
      requireEqual = true;
    } else {
      const zone1IsGreaterThanZone2 =
        operator === ZONING_RULES_OPERATORS.GREATER_THAN ||
        operator === ZONING_RULES_OPERATORS.GREATER_THAN_OR_EQUAL_TO;

      keyZone = zone1IsGreaterThanZone2 ? zone1 : zone2;
      comparedZone = zone1IsGreaterThanZone2 ? zone2 : zone1;

      allowEqual =
        operator === ZONING_RULES_OPERATORS.GREATER_THAN_OR_EQUAL_TO ||
        operator === ZONING_RULES_OPERATORS.LESS_THAN_OR_EQUAL_TO;
    }

    result[keyZone] = { comparedZone, allowEqual, requireEqual };
  })

  return result
}
